import VueCountdown from '@chenfengyuan/vue-countdown';

export default defineNuxtPlugin(nuxtApp => {
// Doing something with nuxtApp
    nuxtApp.vueApp.component(VueCountdown.name, VueCountdown);
})